import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

/**
 * Authentication guard that checks if user is logged in by verifying the .timer.portal cookie exists.
 * If not authenticated, redirects to log-out page.
 */
export const authGuard: CanActivateFn = () => {
  const cookieService = inject(CookieService);
  const router = inject(Router);

  const timerCookie = cookieService.get('.timer.portal');
  const isAuthenticated = !!timerCookie && !isNaN(new Date(timerCookie).getTime());

  if (!isAuthenticated) {
    router.navigate(['/log-out']);
    return false;
  }

  return true;
};
